import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/search/promo-specialist-painter.webp")